import useRole from "hooks/useRole";
import { RbacsProps, UserRole } from "types";

const RBACSwitcher = ({
  student,
  teacher,
  adminSchool,
  admin,
  inspecteur,
  parent,
}: RbacsProps) => {
  const role = useRole();
  return (
    <div>
      {role == UserRole.admin && admin}
      {role == UserRole.student && student}
      {role == UserRole.adminSchool && adminSchool}
      {role == UserRole.teacher && teacher}
      {role == UserRole.inspecteur && inspecteur}
      {role == UserRole.parent && parent}
    </div>
  );
};

export default RBACSwitcher;
